const getters = {
  getCurrentUnloading:(state)=> {
    return state.currentUnloading
  }

}

export default getters